export default {
  anchors: {
    business: 'businesses',
    contact: 'contact',
    experiences: 'experiences',
    jobs: 'jobs',
    profiles: 'profiles',
  },
  beet: 'Site designed and developed by',
  cvLimit: 'The file must not be larger than 10 Mb.',
  errors: {
    email: 'The email address is invalid.',
    emailSize: "The email's length must not exceed 255 characters.",
    file: 'The file must not be larger than 10 Mb.',
    motivation: 'The motivation text length must not exceed 500 characters.',
    name: "The name's length must not exceed 255 characters.",
    title: "The title's length must not exceed 255 characters.",
  },
  gdpr: {
    banner: {
      accept: 'ACCEPT COOKIES',
      description:
        'We use cookies to make this site work and to help us make improvements. Clicking accept will enable us to set recommended analytics cookies.',
      settings: 'CHANGE COOKIES SETTINGS',
      title: 'Our use of cookies',
    },
    settings: {
      analytics: {
        description:
          "We'd like to set Google Analytics cookies to help us to improve our website by collecting and reporting information on how you use it. The cookies collect information in a way that does not directly identify anyone. For more information on how these cookies work, please see our Privacy & Cookies page.",
        title: 'Analytics cookies',
      },
      description:
        "We use essential cookies to make our site work. We'd also like to set optional analytics cookies to help us improve it. We won't set optional cookies unless you enable them. Using this tool will set a cookie on your device to remember your preferences. For more detailed information about the cookies we use, see our Privacy & Cookies page.",
      essentials: {
        description:
          'Essential cookies enable core functionality such as security, network management, and accessibility. You may disable these by changing your browser settings, but this may affect how the website functions.',
        title: 'Essential cookies',
      },
      save: 'Save and close',
      title: 'Our use of cookies',
    },
  },
  hours: '{hours} hours per week',
  salary: '{salary}$ an hour',
}
